import { PropsWithChildren } from 'react'

import { PrimaryCell, PrimaryCellProps } from '@revolut-internal/ui-kit-table'

import { SelectableCell } from 'pages/Monitoring/components/SelectableCell'
import { ResourceFilterType, ResourcesSideParams } from 'types'

import { QueueHealthDetailFormattedData } from '../types'

export type ShowResourcesCellProps = PrimaryCellProps<QueueHealthDetailFormattedData> & {
  filterType: ResourceFilterType
  resourcesSideParams?: ResourcesSideParams
  hasAccess: boolean
  onShowResources: (value: ResourcesSideParams | undefined) => void
}
export const ShowResourcesCell = ({
  resourcesSideParams,
  filterType,
  hasAccess,
  onShowResources,
  children,
  ...restCellProps
}: PropsWithChildren<ShowResourcesCellProps>) => {
  const row = restCellProps.cell.row

  const entityCommonProps = {
    name: row.original.name,
    id: row.original.id,
  }
  const isSelected =
    resourcesSideParams?.filterType === filterType &&
    [resourcesSideParams.queue?.id, resourcesSideParams.specialisation?.id].includes(
      row.original.id,
    )

  return hasAccess ? (
    <SelectableCell
      isSelected={isSelected}
      onClick={() =>
        onShowResources(
          isSelected
            ? undefined
            : Object.assign(
                { filterType },
                row.depth
                  ? {
                      queue: entityCommonProps,
                    }
                  : {
                      specialisation: {
                        ...entityCommonProps,
                        ongoingIncidents: row.original.ongoingIncidents,
                        alertingPolicies: row.original.alertingPolicies,
                      },
                    },
              ),
        )
      }
      {...restCellProps}
    >
      {children}
    </SelectableCell>
  ) : (
    <PrimaryCell {...restCellProps}>{children}</PrimaryCell>
  )
}
